import { api } from '@/lib/api-manager'

export async function getUniquePreviousEducations(
  pageParam: number,
  term: string
) {
  const response = await api.get('v1/educations/previous-educations', {
    params: { pageParam, term }
  })

  return response.data
}
